<!-- <p>pre-approve-dialog works!</p> -->
<div class="pre-approve-dialog-container">
  <div class="mat-dialog-header">
    <h1 mat-dialog-title>
      Pre-Approve Visitor
      <button mat-mini-fab mat-dialog-close class="close-btn">
        <mat-icon>close</mat-icon>
      </button>
    </h1>
  </div>

  <mat-dialog-content class="mat-typography">
    <div class="dialog-content">
      <form [formGroup]="preApproveForm">
        <!-- Service Selection -->
        <div class="form-section">
          <h3 class="section-title">
            <mat-icon>business</mat-icon>
            Select Service
          </h3>
          <mat-form-field
            appearance="outline"
            class="full-width"
            subscriptSizing="dynamic"
          >
            <mat-label>Choose Service</mat-label>
            <mat-select
              (selectionChange)="onSelectionChange()"
              formControlName="selectControl"
            >
              <!-- 🛒 Shopping & Food -->
              <mat-optgroup label=" Shopping & Food">
                <mat-option value="Amazon">
                  <i class="fab fa-amazon blue-color-icons"></i> Amazon
                </mat-option>
                <mat-option value="Flipkart">
                  <i class="fas fa-store blue-color-icons"></i> Flipkart
                </mat-option>
                <mat-option value="Myntra">
                  <i class="fas fa-tshirt blue-color-icons"></i> Myntra
                </mat-option>
                <mat-option value="Swiggy">
                  <i class="fas fa-hamburger blue-color-icons"></i> Swiggy
                </mat-option>
                <mat-option value="Zomato">
                  <i class="fas fa-pizza-slice blue-color-icons"></i> Zomato
                </mat-option>
                <mat-option value="Blinkit">
                  <i class="fas fa-bolt blue-color-icons"></i> Blinkit
                </mat-option>
                <mat-option value="BigBasket">
                  <i class="fas fa-shopping-basket blue-color-icons"></i>
                  BigBasket
                </mat-option>
                <mat-option value="Dunzo">
                  <i class="fas fa-biking blue-color-icons"></i> Dunzo
                </mat-option>
              </mat-optgroup>

              <!-- 🚗 Transportation -->
              <mat-optgroup label="Transportation">
                <mat-option value="Uber">
                  <i class="fas fa-taxi blue-color-icons"></i> Uber
                </mat-option>
                <mat-option value="Ola">
                  <i class="fas fa-car-side blue-color-icons"></i> Ola
                </mat-option>
                <mat-option value="Rapido">
                  <i class="fas fa-motorcycle blue-color-icons"></i> Rapido
                </mat-option>
              </mat-optgroup>

              <!-- 🔧 Home Services -->
              <mat-optgroup label=" Home Services">
                <mat-option value="Plumber">
                  <i class="fas fa-tools blue-color-icons"></i> Plumber
                </mat-option>
                <mat-option value="Electrician">
                  <i class="fas fa-bolt blue-color-icons"></i> Electrician
                </mat-option>
                <mat-option value="Carpenter">
                  <i class="fas fa-hammer blue-color-icons"></i> Carpenter
                </mat-option>
                <mat-option value="Laundrymen">
                  <i class="fas fa-soap blue-color-icons"></i> Laundry Service
                </mat-option>
                <mat-option value="Painter">
                  <i class="fas fa-paint-roller blue-color-icons"></i> Painter
                </mat-option>
                <mat-option value="Cleaner">
                  <i class="fas fa-broom blue-color-icons"></i> Cleaner
                </mat-option>
              </mat-optgroup>

              <!-- 🏠 Regular Services -->
              <mat-optgroup label="Regular Services">
                <mat-option value="Milkman">
                  <i class="fas fa-glass-whiskey blue-color-icons"></i> Milk
                  Delivery
                </mat-option>
                <mat-option value="Help">
                  <i class="fas fa-user-nurse blue-color-icons"></i> Domestic
                  Help
                </mat-option>
                <mat-option value="Cook">
                  <i class="fas fa-utensils blue-color-icons"></i> Cook
                </mat-option>
              </mat-optgroup>

              <!-- 📋 Other -->
              <mat-optgroup label=" Other">
                <mat-option value="Other">
                  <i class="fas fa-ellipsis-h blue-color-icons"></i> Other
                </mat-option>
              </mat-optgroup>
            </mat-select>
          </mat-form-field>
        </div>

        <!-- Delivery Instructions -->
        <div
          class="form-section"
          *ngIf="preApproveForm.controls.selectControl.value"
        >
          <h3 class="section-title">
            <mat-icon>location_on</mat-icon>
            Meeting Instructions
          </h3>

          <!-- Delivery Services Instructions -->
          <mat-radio-group
            *ngIf="isDeliveryService()"
            class="instruction-radio-group"
            formControlName="instructionControl"
            (change)="onChangeInstruction($event)"
          >
            <mat-radio-button value="Leave at Gate" class="radio-option">
              <div class="radio-content">
                <span>Leave at Gate</span>
              </div>
            </mat-radio-button>
            <mat-radio-button value="Leave at Door" class="radio-option">
              <div class="radio-content">
                <span>Leave at Door</span>
              </div>
            </mat-radio-button>
            <mat-radio-button value="Meet at Gate" class="radio-option">
              <div class="radio-content">
                <span>Meet at Gate</span>
              </div>
            </mat-radio-button>
            <mat-radio-button value="Meet inside" class="radio-option">
              <div class="radio-content">
                <span>Meet Inside</span>
              </div>
            </mat-radio-button>
            <mat-radio-button value="Leave with Neighbour" class="radio-option">
              <div class="radio-content">
                <span>Leave with Neighbour</span>
              </div>
            </mat-radio-button>
          </mat-radio-group>

          <!-- Service Provider Instructions -->
          <mat-radio-group
            *ngIf="isServiceProvider()"
            class="instruction-radio-group"
            formControlName="instructionControl"
            (change)="onChangeInstruction($event)"
          >
            <mat-radio-button value="Meet at Gate" class="radio-option">
              <div class="radio-content">
                <span>Meet at Gate</span>
              </div>
            </mat-radio-button>
            <mat-radio-button
              *ngIf="isTransportService()"
              value="Meet inside"
              class="radio-option"
            >
              <div class="radio-content">
                <span>Meet Inside</span>
              </div>
            </mat-radio-button>
            <mat-radio-button
              *ngIf="!isTransportService()"
              value="Meet at Door"
              class="radio-option"
            >
              <div class="radio-content">
                <span>Meet at Door</span>
              </div>
            </mat-radio-button>
            <mat-radio-button
              *ngIf="!isTransportService()"
              value="Meet with Neighbour"
              class="radio-option"
            >
              <div class="radio-content">
                <span>Meet with Neighbour</span>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <!-- Neighbour Selection -->
        <div class="form-section" *ngIf="showNeighbourSelection()">
          <h3 class="section-title">
            <mat-icon>person_search</mat-icon>
            Select Neighbour
          </h3>
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Choose Neighbour</mat-label>
            <input
              matInput
              [formControl]="hostFilter"
              [matAutocomplete]="auto"
            />
            <mat-autocomplete
              (optionSelected)="onOptionSelected($event)"
              #auto="matAutocomplete"
            >
              <mat-option
                *ngFor="let host of filteredHosts"
                [value]="host.firstname + ' ' + host.lastname"
              >
                <mat-icon>person</mat-icon>
                {{ host.firstname + " " + host.lastname }}
              </mat-option>
            </mat-autocomplete>
          </mat-form-field>
        </div>

        <!-- Date Selection -->
        <div class="form-section">
          <h3 class="section-title">
            <mat-icon>schedule</mat-icon>
            When?
          </h3>
          <mat-radio-group
            class="date-radio-group"
            formControlName="radioControl"
            (change)="onChange($event)"
          >
            <mat-radio-button value="0" class="radio-option">
              <div class="radio-content">
                <span>Today</span>
              </div>
            </mat-radio-button>
            <mat-radio-button value="1" class="radio-option">
              <div class="radio-content">
                <span>Choose Date</span>
              </div>
            </mat-radio-button>
          </mat-radio-group>

          <mat-form-field
            *ngIf="showDatePicker"
            appearance="outline"
            class="full-width date-picker"
          >
            <mat-label>Select Date</mat-label>
            <input
              matInput
              [matDatepicker]="ChooseDate"
              formControlName="chooseDate"
              [min]="minDate"
            />
            <mat-datepicker-toggle
              matSuffix
              [for]="ChooseDate"
            ></mat-datepicker-toggle>
            <mat-datepicker #ChooseDate></mat-datepicker>
          </mat-form-field>
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="dialog-actions">
    <!-- <button mat-stroked-button mat-dialog-close class="cancel-btn">
      <mat-icon>cancel</mat-icon>
      Cancel
    </button> -->
    <button
      [disabled]="!isFormValid()"
      mat-raised-button
      [mat-dialog-close]="preApproveForm.value"
      class="submit-btn"
    >
      <mat-icon>check_circle</mat-icon>
      Submit
    </button>
  </mat-dialog-actions>
</div>
